export const productIDs = {
    // EDIT PHP RESOURCES FOR INV ITEMS
    splitBolt: 'ASPLTC10-EB',
    colorReel: {
        0: 'PBRC1000W2-EB', //whiteReel
        1: 'PBRC1000B2-EB', // blackReel
        2: 'PBRC1000C2-EB', //checkeredReel
    },

    rollerInsulators: 'IROLLB10-EB',
    linePostInsulators: 'IWHDCLAWB-EB',

    // rollerInsulatorsWHT: 'IROLLW10-EB', // EDIT PHP RESOURCES FOR INV ITEMS
    // linePostInsulatorsWHT: 'IWHDCLAWW-EB',
    // tPostInsulatorsWHT: 'ITW-EB',
    // tPostCapWHT: 'ITCPW-EB',

    //    linePostInsulatorsOffSet: 'IWNB-EB',

    shortScrews: 'AS1-EB', // EDIT PHP RESOURCES FOR INV ITEMS
    longScrews: 'AS25-EB',

    // default order addition
    leadOutWire: 'UGCC200-EB', // EDIT PHP RESOURCES FOR INV ITEMS
    groundRodClamps: 'CGRC3-EB',
    tensionKit: 'ATENSIONKIT-EB',
    digitalFenceTester: 'DVM-EB',

    gateKit: 'GHWKRW-EB',

    tPostInsulators: 'ITB-EB',
    tPostCap: 'ITCPB-EB',
    groundRods: 'GRSC8-EB',
    energizer: 'EAC50M-Z',
    energizerLg: 'EAC75M-Z', // only valid if m_EnrgzerTrigger is set from 0
}
